// @flow
import React from 'react';
import PropTypes from 'prop-types';
import dashboardMessages from '../../data/dashboard';
import DashboardLoadingPlaceholder from './DashboardLoadingPlaceholderComponent';

type Props = {
  isLoading: boolean,
  info: {
    name: string,
    email: string,
    phone: string,
  },
};

type Context = {
  intl: Object,
};

const AccountManagerComponent = ({ isLoading, info }: Props, { intl }: Context) => (
  <div className="u-marginTop-s u-marginTop-m@large u-padding-horizontal-m u-padding-vertical-s u-padding-vertical-m@large dashboard-page__account-manager dashboard-page__item">
    <h3 className="u-marginBottom-s u-marginBottom-m@large u-paddingBottom-s u-paddingBottom-m@large u-fontSize-xl dashboard-page__item-heading">
      {intl.formatMessage(dashboardMessages.dashboardAccountManagerTitle)}
    </h3>
    {isLoading ? (
      <DashboardLoadingPlaceholder type="triple" />
    ) : (
      <div>
        <div className="u-fontSize-m  u-fontFamily-primaryMedium">{info.name}</div>
        <div className="u-fontSize-m">{info.phone}</div>
        <div className="u-fontSize-m">{info.email}</div>
      </div>
    )}
  </div>
);

AccountManagerComponent.displayName = 'AccountManager';

AccountManagerComponent.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default AccountManagerComponent;
